import { Form, Input } from "antd";
import { useRouter } from "next/router";

import Helpers from "../../services/helpers";
import Services from "../../services";
import Toaster from "../../services/toaster";
import { COLLECTION_TYPES } from "../../globals";
import useGlobal from "../../store";
import { generateQueryString } from "./generateQueryString";

const SaveSearchForm = ({ getTerms, type, setShowSavedSearchForm }) => {
  const [, globalActions] = useGlobal();
  const router = useRouter();

  const saveSearch = async (title) => {
    if (title.length) {
      const search = generateQueryString(getTerms(), type);
      const savedSearchResponse = await Services.saveSavedSearch({
        title,
        search,
        query: search,
        type,
      }).catch((e) => {
        Helpers.handleApiError(e, router);
      });

      if (savedSearchResponse.errorMessage) Toaster.ErrorNotification("Unabled to save search.");
      else {
        Toaster.SuccessNotification("Search saved!");
        globalActions.addNewItem({
          item: savedSearchResponse,
          objectType: type,
          collectionType: COLLECTION_TYPES.SAVED_SEARCH,
        });
        setShowSavedSearchForm(false);
      }
    }
  };

  return (
    <div id="saveSearchForm">
      <Form.Item label="Save this search">
        <Input.Search placeholder="Title of search" onSearch={(value) => saveSearch(value)} enterButton="Save" />
      </Form.Item>
    </div>
  );
};

export default SaveSearchForm;
